let cached = { token: null, until: 0 };
let listener = null;

export const getReauthToken = () => (cached.token && Date.now() < cached.until ? cached.token : null);

export const storeReauthToken = (token, expiresIn) => {
  cached = { token, until: Date.now() + Math.max(30, (expiresIn || 300) - 15) * 1000 };
};

export const clearReauthToken = () => { cached = { token: null, until: 0 }; };

export const onReauthRequest = (cb) => { listener = cb; return () => { if (listener === cb) listener = null; }; };

export const requestReauth = (detail) => new Promise((resolve) => {
  if (!listener) { resolve(null); return; }
  listener({ detail, resolve });
});
